import {agencesConstants} from './agences.constants';
import {authenticationConstants} from "../authentication/auth.constants";

const initialState = {agences: null, agence: null, loading: false, error: null}

export function agences(state = initialState, action) {
    switch (action.type) {
        case agencesConstants.AGENCES_FETCH_REQUEST:
        case agencesConstants.AGENCES_CREATE_REQUEST:
        case agencesConstants.AGENCES_UPDATE_REQUEST:
        case agencesConstants.AGENCES_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case agencesConstants.AGENCES_FETCH_ONE_REQUEST:
            return {
                ...state,
                agence: null,
                loading: true,
                error: null
            };
        case agencesConstants.AGENCES_FETCH_SUCCESS:
            return {
                ...state,
                agences: action.agences,
                loading: false,
                error: null
            };
        case agencesConstants.AGENCES_FETCH_ONE_SUCCESS:
            return {
                ...state,
                agence: action.agence,
                loading: false,
                error: null
            };
        case agencesConstants.AGENCES_CREATE_SUCCESS:
        case agencesConstants.AGENCES_UPDATE_SUCCESS:
        case agencesConstants.AGENCES_DELETE_SUCCESS:
            return {
                ...state,
                agences: null,
                agence: null,
                loading: false,
                error: null
            };
        case agencesConstants.AGENCES_FETCH_FAILURE:
        case agencesConstants.AGENCES_FETCH_ONE_FAILURE:
        case agencesConstants.AGENCES_CREATE_FAILURE:
        case agencesConstants.AGENCES_UPDATE_FAILURE:
        case agencesConstants.AGENCES_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case authenticationConstants.LOGOUT:
            return {
                initialState
            }
        default:
            return state;
    }
}
